import { RUNTIME_OFFLINE_BANNER_MESSAGE } from "@lifter/hub-ui/browser-shared";
import { AlertTriangle } from "lucide-react";
import { LiveRegion } from "../components/ui/live-region";
import { usePortalOrg } from "../org/context";

export function RuntimeOfflineBanner() {
  const { gatewayOnline, gateway } = usePortalOrg();
  const offline = !gatewayOnline && gateway.status !== "checking";

  return (
    <LiveRegion>
      {offline ? (
        <div className="mb-6 flex items-center gap-3 rounded-md border border-[color-mix(in_srgb,var(--color-warning)_35%,transparent)] bg-[var(--color-warning-soft)] px-4 py-3 text-[var(--color-warning)]">
          <AlertTriangle aria-hidden="true" className="size-4 shrink-0" />
          <p className="type-body leading-snug">{RUNTIME_OFFLINE_BANNER_MESSAGE}</p>
        </div>
      ) : null}
    </LiveRegion>
  );
}
